import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function ServerErrorPage() {
  const navigate = useNavigate();

  return (
    <Result
      status="500"
      title="500"
      subTitle="¡Ups! Algo salió mal en el servidor. Inténtalo de nuevo más tarde."
      extra={
        <Button type="primary" onClick={() => navigate("/")}>
          Volver al inicio
        </Button>
      }
    />
  );
}
